module.exports = __webpack_public_path__ + "img/OJ.c3ae01af.png";